import { IResolvers as ICoreResolvers, IClientService, GoToLineQuickAccessDocument, CacheTypenames } from '@workbench-stack/core';

const gotoLineQuickAccessResolvers: (services: () => IClientService) => ICoreResolvers = (services) => {
    return ({
        Mutation: {
            highlightLine: (_, args, context) => {
                const { range } = args;
                context.client.writeQuery({
                    query: GoToLineQuickAccessDocument,
                    data: {
                        gotoLineQuickAccess: {
                            range: range && { ...range, __typename: CacheTypenames.LineRange },
                            highlight: true,
                            focus: false,
                            __typename: CacheTypenames.GoToLineQuickAccess,
                        },
                    },
                });
                return true;
            },
            gotoLine: (_, args, context) => {
                const { range } = args;
                context.client.writeQuery({
                    query: GoToLineQuickAccessDocument,
                    data: {
                        gotoLineQuickAccess: {
                            range: range && { ...range, __typename: CacheTypenames.LineRange },
                            highlight: false,
                            focus: true,
                            __typename: CacheTypenames.GoToLineQuickAccess,
                        },
                    },
                });
                return true;
            },
        },
    });
};

export { gotoLineQuickAccessResolvers };
